import React from 'react';
import Header from 'components/Admin/shared/Table/Header.jsx';

const titles = {
  title: 'TITLE',
  namespace: 'ROLE'
};

const additionalProps = {};

function HeadersDisciplines({
                   onChange,
                   value: selectedValue
                 }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map(value => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value]) || {}}
        />
      ))}
    </tr>
  );
}

HeadersDisciplines.defaultProps = {};

HeadersDisciplines.propTypes = {};

export default HeadersDisciplines;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/ListDisciplines/HeadersDisciplines.jsx